module.exports = __webpack_public_path__ + "static/07-b037266b5e1c70aa5d3988b152bb324a.jpg";